// WHAT CAN BE CHANGED?
// You can make style changes accordingly

<template>
    <div id="chatPermission">
        <h2 id="chatPermission__title">Bericht sturen aan de DJ's?</h2>
        <p>Voordat u een bericht kunt sturen hebben wij eerst uw naam nodig:</p>
        <input class="chatPermission__text-input" v-model="username" placeholder="Typ hier je naam" type="text" id="chatPermission__username" @focus="setKeyboardActive()" @blur="setKeyboardSedentary()" required/>
        <p>Mocht u gebeld willen worden door de studio, kunt u hier uw nummer achterlaten:</p>
        <input class="chatPermission__text-input" v-model="phone" placeholder="Typ hier je telefoonnummer" type="tel" id="chatPermission__phonenumber" @focus="setKeyboardActive(); scrollDown()" @blur="setKeyboardSedentary()" />
        <p id="chatPermission__disclaimer"><i>Bij het versturen van berichten gaat u ermee akkoord dat de studio uw antwoord mag verwerken en in de uitzending mag gebruiken. Uw naam en telefoonnummer worden opgeslagen totdat u de app verwijdert van uw telefoon.</i></p>
        <label class="chatPermission__checkbox">
            <input type="checkbox" required v-model="checked">
            <span class="chatPermission__checkbox__checkmark"></span>
            <span>Ik ga akkoord</span>
        </label>
        <br>
        <button type="submit" id="chatPermission__submit" :disabled="!checked || !username" v-on:click="setUserData(); setKeyboardSedentary()">Verstuur</button>
    </div>
</template>

<script>
export default {
    name: "chatPermission",
    props: {
        userData: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            username: null,
            phone: null,
            checked: null
        }
    },
    methods: {
        setUserData() {
            this.$props.userData[0].username = this.username;
            this.$props.userData[0].phone = this.phone;
            this.$props.userData[0].permissionGranted = true;
            localStorage.setItem("permissionGranted", JSON.stringify(this.userData[0].permissionGranted));
            localStorage.setItem("username", JSON.stringify(this.userData[0].username));
            localStorage.setItem("phone", JSON.stringify(this.userData[0].phone));
        },
        scrollDown() {
            window.scrollTo(0,document.querySelector("#app").scrollHeight);
        },
        setKeyboardActive() {

            setTimeout(() => {
                document.getElementById("message").style.paddingBottom = "0px";
                document.getElementById("app").style.paddingBottom = "15px";
                document.body.classList.add("when-keyboard-active");
                document.getElementById("message").classList.add("keyboard-space");
            }, 100)
        },
        setKeyboardSedentary() {

            setTimeout(() => {
                document.getElementById("message").style.paddingBottom = "74px";
                document.getElementById("app").style.paddingBottom = "56px";
                document.body.classList.remove("when-keyboard-active");
                document.getElementById("message").classList.remove("keyboard-space")
                document.getElementById("message").style.paddingBottom = "74px";
            }, 100);
        },
    }
};
</script>

<style lang="scss" scoped>
$chat-permission__text--font: "Lato";
$chat-permission__text--title-colour: #f55000;
$chat-permission__button--colour: #ffc500;

#chatPermission {
    margin: auto;
    margin-top: 2vh;
    padding: 16px;
    width: 300px;
    box-sizing: border-box;
    background-color: #f1f1f1;
    box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.2);
    font-family: $chat-permission__text--font;

    #chatPermission__title {
        color: $chat-permission__text--title-colour;
        font-size: 18px;
        margin-bottom: 4px;
    }

    p {
        margin-bottom: 6px;
    }

    .chatPermission__text-input {
        height: 35px;
        width: 100%;
        font-size: 16px;
        font-style: italic;
        border-radius: 5px;
        border: 2px solid lightgrey;
        padding: 0px 8px;
        box-sizing: border-box;
        margin-bottom: 6px;
    }

    #chatPermission__disclaimer {
        margin-bottom: 12px;
    }

    .chatPermission__checkbox {
        cursor: pointer;
        font-size: 18px;
        position: relative;
        padding-left: 40px;
        padding-top: 3px;
        font-weight: bold;
        
        input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;
        }
        .chatPermission__checkbox__checkmark {
            position: absolute;
            top: 0;
            left: 0;
            height: 25px;
            width: 25px;
            background-color: white;
            border: 2px solid lightgrey;
            border-radius: 5px;
        }

        input:checked ~ .chatPermission__checkbox__checkmark {
            background-color: #f55000 !important;
        }

        .chatPermission__checkbox__checkmark:after {
            content: "";
            position: absolute;
            display: none;   
        }

        input:checked ~ .chatPermission__checkbox__checkmark:after {
            display: block;
        }

        .chatPermission__checkbox__checkmark:after {
            left: 9px;
            top: 5px;
            width: 5px;
            height: 10px;
            border: solid white;
            border-width: 0 3px 3px 0;
            -webkit-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: rotate(45deg);
        }
    }

    #chatPermission__submit {
        font-family: $chat-permission__text--font;
        font-size: 18px;
        font-weight: bold;
        background-color: $chat-permission__button--colour;
        border: none;
        border-radius: 999px;
        margin-left: 54px;
        margin-top: 16px;
        width: 160px;
        height: 40px;

    }

    #chatPermission__submit:disabled {
        background-color: #c1c1c0 !important;
        color: #dedede !important;
    }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    #chatPermission {

    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    #chatPermission {

    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    #chatPermission {

    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    #chatPermission {

    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    #chatPermission {
       
    }
}
</style>